module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8003.3d87b1aa.png";